import { Component } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { SCREENS } from 'src/constants/screens';
import { hasPermissions, hasRole } from 'src/utils/helpers';

interface Props extends RouteProps {
  permissions: string[];
  roles: string[];
  access?: boolean;
  redirectPath?: string;
}

export default class CustomRoute extends Component<Props, {}> {
  static defaultProps = {
    roles: [],
    permissions: [],
    access: true,
  };

  render() {
    const { permissions, roles, access, redirectPath = SCREENS.NOT_FOUND(), ...props } = this.props;
    const shouldRedirect = !hasPermissions(permissions) || !hasRole(roles) || !access;

    // eslint-disable-next-line react/jsx-props-no-spreading
    return shouldRedirect ? <Redirect to={redirectPath} /> : <Route {...props} />;
  }
}
